import _ from 'lodash';

export function extendTaxSettings({ user, taxBenefits, isSuperHost }) {
  const settings = { ...user.settings, taxBenefits };

  // only set if not true, once a superhost always a superhost
  if (!_.get(user, 'settings.isSuperHost')) {
    settings.isSuperHost = isSuperHost;
  }

  return settings;
}

export function getReplacementArgs(isSuperHost: boolean) {
  const hostType = isSuperHost ? 'Superhost' : 'host';
  const hostsType = `${hostType}s`;
  const discountAmount = isSuperHost ? '20%' : '20%';

  return {
    hostType,
    hostsType,
    discountAmount,
  };
}
